import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CampaignItemContainer = styled(Stack)(() => ({
  borderRadius: '0.75rem',
  backgroundColor: '#f5f5f7',
  padding: '0.25rem 0.5rem',
}));

export const StatusBadge = styled('div')<{
  statustype: string;
}>(({ statustype, theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 400,
  borderRadius: '0.4375rem',
  padding: '0 0.44rem',

  ...(statustype === 'ACTIVE' && {
    backgroundColor: theme.palette.green[100],
    color: theme.palette.green[700],
  }),
  ...((statustype === 'PENDING' || statustype === 'CONFIRMED' || statustype === 'APPROVED') && {
    backgroundColor: theme.palette.blue[100],
    color: theme.palette.blue[800],
  }),
  ...(statustype === 'COMPLETED' && {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.grey[800],
  }),
  ...((statustype === 'CANCELLED' || statustype === 'REJECTED') && {
    backgroundColor: theme.palette.red[100],
    color: theme.palette.red[600],
  }),
}));

export const BrandName = styled('span')(
  () => `
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    border-radius: 0;

    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 160%;
    color: #615e6f;
  `,
);

export const AdvertiserName = styled('p')(
  () => `
  margin: 0;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
  color: #615e6f;
`,
);

export const CampaignPeriod = styled('p')(
  ({ theme }) => `
  margin: 0;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 400;
  line-height: 160%; 
  color: ${theme.palette.grey[800]};
`,
);
